import { ServiceCenter } from './service-center';

export class Funder {
	readonly id: number;
	name: string;
	serviceCenter: ServiceCenter;
}
